// extracted by mini-css-extract-plugin
module.exports = {"textSize":"PrivacyStatement_textSize__1Yjx6"};